import { DependencyList, EffectCallback, useEffect, useRef } from 'react'
import { isEqual } from 'lodash'

export function useDeepEqualMemo<T>(value: T) {
  const ref = useRef<T | undefined>(value)

  if (!isEqual(ref.current, value)) {
    ref.current = value
  }

  return ref.current
}

export function useDeepCompareEffect(
  callback: EffectCallback,
  deps: DependencyList
) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, useDeepEqualMemo(deps))
}
